import type { LiveAiChatScope } from './ai-chat-live-content'
import { AiChatScopeType } from '@/graphql/schema'

export type AiChatScopeInput = {
  documentCollectionId?: string
  scope: LiveAiChatScope
  workspaceId?: string
}

export function getAiChatScopeVariables(input: AiChatScopeInput) {
  return {
    workspaceId: input.workspaceId ?? '',
    scopeType:
      input.scope === 'workspace'
        ? AiChatScopeType.Workspace
        : AiChatScopeType.DocumentCollection,
    scopeDocumentCollectionId:
      input.scope === 'documentCollection'
        ? input.documentCollectionId
        : undefined,
  }
}

export function isAiChatUnscoped(input: AiChatScopeInput) {
  return (
    !input.workspaceId ||
    (input.scope === 'documentCollection' && !input.documentCollectionId)
  )
}
